import React from 'react';

import { SvgProps } from '../enums';

export const FlagBY: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_54967"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_54967)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V12H0V0Z"
        fill="#73BE4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V8H16V0H0Z"
        fill="#AF0100"
      />
      <rect width="3" height="12" fill="#F7FCFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M0.499989 0C0.776153 0 0.999985 0.223875 0.999985 0.50001C0.999985 0.776145 0.776153 1.00002 0.499989 1.00002C0.223888 1.00002 0 0.776145 0 0.50001C0 0.223875 0.223888 0 0.499989 0ZM2.50003 0C2.77613 0 3.00002 0.223875 3.00002 0.50001C3.00002 0.776145 2.77613 1.00002 2.50003 1.00002C2.22387 1.00002 2.00003 0.776145 2.00003 0.50001C2.00003 0.223875 2.22387 0 2.50003 0ZM0.999985 2.50002C0.999985 2.22384 0.776153 2.00001 0.499989 2.00001C0.223888 2.00001 0 2.22384 0 2.50002C0 2.77615 0.223888 2.99998 0.499989 2.99998C0.776153 2.99998 0.999985 2.77615 0.999985 2.50002ZM2.50003 2.00001C2.77613 2.00001 3.00002 2.22384 3.00002 2.50002C3.00002 2.77615 2.77613 2.99998 2.50003 2.99998C2.22387 2.99998 2.00003 2.77615 2.00003 2.50002C2.00003 2.22384 2.22387 2.00001 2.50003 2.00001ZM2.50003 9.00001C2.77613 9.00001 3.00002 9.22385 3.00002 9.50002C3.00002 9.77614 2.77613 9.99999 2.50003 9.99999C2.22387 9.99999 2.00003 9.77614 2.00003 9.50002C2.00003 9.22385 2.22387 9.00001 2.50003 9.00001ZM0.999985 9.50002C0.999985 9.22385 0.776153 9.00001 0.499989 9.00001C0.223888 9.00001 0 9.22385 0 9.50002C0 9.77614 0.223888 9.99999 0.499989 9.99999C0.776153 9.99999 0.999985 9.77614 0.999985 9.50002ZM0.499989 11C0.776153 11 0.999985 11.2239 0.999985 11.5C0.999985 11.7762 0.776153 12 0.499989 12C0.223888 12 0 11.7762 0 11.5C0 11.2239 0.223888 11 0.499989 11ZM3.00002 11.5C3.00002 11.2239 2.77613 11 2.50003 11C2.22387 11 2.00003 11.2239 2.00003 11.5C2.00003 11.7762 2.22387 12 2.50003 12C2.77613 12 3.00002 11.7762 3.00002 11.5ZM1.49997 9.99999C1.77614 9.99999 2.00003 10.2239 2.00003 10.5C2.00003 10.7761 1.77614 11 1.49997 11C1.22388 11 0.999985 10.7761 0.999985 10.5C0.999985 10.2239 1.22388 9.99999 1.49997 9.99999ZM2.00003 1.5C2.00003 1.22387 1.77614 1.00002 1.49997 1.00002C1.22388 1.00002 0.999985 1.22387 0.999985 1.5C0.999985 1.77613 1.22388 2.00001 1.49997 2.00001C1.77614 2.00001 2.00003 1.77613 2.00003 1.5ZM2.05499 6.01935L3.00002 7V7.99998L3.02189 8.04642L1.54555 6.56887L0.218827 7.99998H0.000126004V7L0.991283 6.01416L0.000126004 5.02219V4.00002H0.109025L1.53185 5.47649L2.9616 4.05439L3.00002 4.00002V4.99996L2.05499 6.01935ZM1.49997 2.99998C1.77614 2.99998 2.00003 3.22388 2.00003 3.49999C2.00003 3.77613 1.77614 4.00002 1.49997 4.00002C1.22388 4.00002 0.999985 3.77613 0.999985 3.49999C0.999985 3.22388 1.22388 2.99998 1.49997 2.99998ZM2.00003 8.49999C2.00003 8.22387 1.77614 7.99998 1.49997 7.99998C1.22388 7.99998 0.999985 8.22387 0.999985 8.49999C0.999985 8.77612 1.22388 9.00001 1.49997 9.00001C1.77614 9.00001 2.00003 8.77612 2.00003 8.49999Z"
        fill="#D0181A"
      />
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M0 0H0.999985V1.00002H0V0ZM0.999985 2.00001H0V2.99998H0.999985V2.00001ZM0 4.00002H0.999985V5H0V4.00002ZM0.999985 7H0V7.99998H0.999985V7ZM0 9.00001H0.999985V9.99999H0V9.00001ZM0.999985 11H0V12H0.999985V11ZM3.00002 11H2.00003V12H3.00002V11ZM3.00002 0H2.00003V1.00002H3.00002V0Z"
        fill="#8F181A"
      />
    </g>
  </svg>
);
